<div class="row mb-4">
    <div class="col-12 mb-4">
        <h5 class="text-white">ESTADO GENERAL</h5>
        <div class="row" *ngIf="dataStatusWarehouseAllExistence">
            <div class="col col-sm-6">
                <div class="container-3d">
                    <app-view-warehouse-cylinder-multi
                    [title]="'Todas'"
                    [percentageLine]="1"
                    [liquids]="liquidLayersAll"
                    [activeModal]="false"
                    >
                    </app-view-warehouse-cylinder-multi>
                </div>
            </div>
            <div class="col col-sm-6">
                <div class="container-3d p-2 overflow-auto">
                    <!-- <h5 class="text-white">T</h5>s -->
                    <div class="row">
                        <div class="table-responsive" style="margin-bottom: 0">
                        <table
                            class="table table-bordered"
                            style="margin-bottom: 0; margin-top: 1em"
                        >
                            <thead>
                                <tr>
                                    <th>Bodega</th>
                                    <th>Contenido Total</th>
                                    <th>% Total de Bodegas</th>
                                    <th>% de la Bodega</th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngFor="let item of dataStatusWarehouseAllExistence.details">
                                    <tr>
                                        <td class="bg-transparent" [ngStyle]="{'max-width': '300px'}">
                                            <span [ngStyle]="{'color': item.colorHex}" class="font-bold">{{item.warehouse.name}}</span>
                                        </td>
                                        <td class="bg-transparent text-right" [ngStyle]="{'color': item.colorHex}">{{item.totalQuantityWarehouse | number:'1.2-2'}}</td>
                                        <td class="bg-transparent text-right" [ngStyle]="{'color': item.colorHex}">{{(item.percentageWarehouse*100).toFixed(4)}} %</td>
                                        <td class="bg-transparent text-right" [ngStyle]="{'color': item.colorHex}">{{((item.totalQuantityWarehouse/item.warehouse.maxCapacity)*100).toFixed(0)}} %</td>
                                    </tr>
                                    <tr>
                                        <td class="bg-transparent" colspan="3">
                                            <table
                                            class="table bg-transparent"
                                            style="margin-bottom: 0; margin-top: 1em"
                                            >
                                                <tbody>
                                                    <ng-container *ngFor="let itemP of item.details">
                                                        <tr class="border-0">
                                                            <td class="bg-transparent" [ngStyle]="{'max-width': '100px'}">
                                                                <span class="text-white">{{itemP.product.name}}</span>
                                                            </td>
                                                            <td class="bg-transparent text-right">
                                                                <span class="text-white">{{itemP.quantity | number:'1.2-2'}}</span>
                                                            </td>
                                                            <td class="bg-transparent text-right">
                                                                <span class="text-white">{{((itemP.quantity/item.totalQuantityWarehouse)*100).toFixed(4)}} %</span>
                                                            </td>
                                                        </tr>
                                                    </ng-container>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </ng-container>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colspan="2" class="bg-transparent text-white">% Total de las bodegas</td>
                                    <td class="bg-transparent text-white">
                                        {{(totalPercentage*100).toFixed(2)}}%
                                    </td>
                                    <td class="bg-transparent text-white"></td>
                                </tr>
                            </tfoot>
                        </table>
                        
                            <!-- <div class="col-12">
                                <span [ngStyle]="{'color': item.colorHex}" class="font-bold">{{item.warehouse.name}} - {{item.totalQuantityWarehouse.toFixed(4)}} - {{item.percentageWarehouse.toFixed(4)}}</span>
                                <div class="pl-4">
                                    <ng-container *ngFor="let itemP of item.details">
                                        <span class="text-white">{{itemP.product.name}} - {{itemP.quantity.toFixed(4)}} - {{(itemP.quantity/item.totalQuantityWarehouse).toFixed(4)}}</span>
                                    </ng-container>
                                </div>
                            </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-12 mt-4">
        <h5 class="text-white">ESTADO INDIVIDUAL</h5>
        <div class="row">
            <div class="col-sm-6 form-group mb-4">
                <label for="product-order" class="form-label text-white">Bodega/Cilindro</label>
                <div class="input-group bg-white rounded">
                    <app-input-autocomplete
                        [allBorderRadius]="true"
                        [inputs]="inputs.warehouse"
                        [placeholder]="'Ingresa una bodega'"
                        [filterElements]="filterWarehouse"
                        (inputMethod)="writeWarehouse($event.event)"
                        (changeStatus)="checkWarehouse($event.filterElement)"
                        (getTitle)="
                            $event.filterElement.title =
                                $event.filterElement.code +
                                ' - ' +
                                $event.filterElement.name
                        "
                    ></app-input-autocomplete>
                </div>
            </div>
            <div class="col-sm-6 form-group mb-4">
                <label for="product-order" class="form-label text-white">Producto</label>
                <div class="input-group bg-white rounded">
                    <app-input-autocomplete
                        [allBorderRadius]="true"
                        [inputs]="inputs.product"
                        [placeholder]="'Ingresa un producto'"
                        [filterElements]="filterProducts"
                        (inputMethod)="writeProduct($event.event)"
                        (changeStatus)="checkProduct($event.filterElement)"
                        (getTitle)="
                            $event.filterElement.title =
                                $event.filterElement.code +
                                ' - ' +
                                $event.filterElement.name
                        "
                    ></app-input-autocomplete>
                </div>
            </div>
        </div>
    </div>

    <div class="col-12 mb-4" *ngIf="dataStatusWarehouse">
        <div class="container-3d">
            <app-view-warehouse-cylinder-multi
            
            [title]="dataStatusWarehouse.warehouse.name"
            [percentageLine]="dataStatusWarehouse.percentageInUsed"
            [liquids]="liquidLayers"
            >
                <div class="row" data-body>
                    <h5 class="text-white text-truncate">Bodega: {{dataStatusWarehouse.warehouse.name}}</h5>
                    <h6 class="text-white text-truncate">Producto: {{dataStatusWarehouse.productData.name}}</h6>
                    <span>Capacidad MAX: {{dataStatusWarehouse.warehouse.maxCapacity}} {{dataStatusWarehouse.measurement.unit}}</span>
                    <span class="mb-1">Estado: {{(1 - dataStatusWarehouse.percentageInUsed)*100}}% </span>
                    <ng-container *ngFor="let item of dataStatusWarehouse.details">
                        <span [ngStyle]="{'color': item.belongsToType=== 1 ? '#00E300' : item.belongsToType=== 2 ? '#FFFF00' : 'white'}">
                            {{item.belongsTo}}: {{item.quantity}}  -  {{item.percentage*100}}%
                        </span>
                    </ng-container>
                </div>
            </app-view-warehouse-cylinder-multi>
        </div>
    </div>
    <!-- <div class="col-12 mb-4">
        <div class="container-3d">
            <app-view-warehouse-cylinder-multi
            >
            </app-view-warehouse-cylinder-multi>
        </div>
    </div> -->
</div>